import { useEffect, useState } from 'react';

const QUERY = '(prefers-reduced-motion: reduce)';

/** Safe `matchMedia(query).matches` (false where matchMedia is missing or stubbed). */
export function mediaMatches(query) {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false;
  const mq = window.matchMedia(query);
  return Boolean(mq && mq.matches);
}

export function prefersReducedMotion() {
  return mediaMatches(QUERY);
}

export default function usePrefersReducedMotion() {
  const [reduced, setReduced] = useState(prefersReducedMotion);

  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return undefined;
    const mq = window.matchMedia(QUERY);
    if (!mq || typeof mq.addEventListener !== 'function') return undefined;
    const onChange = () => setReduced(mq.matches);
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, []);

  return reduced;
}
